// Every route of the hotel dashboard. Use these instead of hardcoded strings
// so the area can move without breaking links.
export const HOTEL_BASE = '/dashboard/hotel';

export const hotelPaths = {
  dashboard: HOTEL_BASE,
  login: `${HOTEL_BASE}/login`,
  rooms: `${HOTEL_BASE}/rooms`,
  bookings: `${HOTEL_BASE}/bookings`,
  analytics: `${HOTEL_BASE}/analytics`,
  finance: `${HOTEL_BASE}/finance`,
  security: `${HOTEL_BASE}/security`,
  settings: `${HOTEL_BASE}/settings`,
  verifyEmail: `${HOTEL_BASE}/verify-email`,
  verifyEmailSuccess: `${HOTEL_BASE}/verify-email/success`,
};
